import {abTestingSelector} from "@pg-mono/ab-testing";
import {omit} from "@pg-mono/nodash";

import {DSA_RATING_SORT_AB_TEST_ID, isDsaRatingSortTreatmentVariant} from "../../../ab_testing/dsa_rating_sort_ab_test";
import {useAppSelector} from "../../../store/hooks";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {IGetOfferListPayload} from "../../types/GetOfferListPayload";
import {getFetchOfferListQueryData} from "../helpers/get_fetch_offer_list_query_data";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {hasPriceFilter} from "../utils/has_price_filter";

interface IProps {
    latestQuery: IOfferListLatestQuery;
    isLastPage: boolean;
}

export const useFetchAdditionalOfferList = (props: IProps) => {
    const useDsaSort = isDsaRatingSortTreatmentVariant(useAppSelector(abTestingSelector(DSA_RATING_SORT_AB_TEST_ID)));
    const queryWithoutPrice = omit(props.latestQuery, ["price_0", "price_1", "instalment"]);
    const {fullQuery} = getFetchOfferListQueryData(queryWithoutPrice as Record<string, string | string[] | null>, true, useDsaSort);

    const {data: offersWithoutPriceFilterData} = useGetOfferListQuery(fullQuery as IGetOfferListPayload, {
        skip: !props.isLastPage || !hasPriceFilter(props.latestQuery)
    });
    const offersWithoutPriceFilter = offersWithoutPriceFilterData?.results ?? [];

    return offersWithoutPriceFilter;
};
import {abTestingSelector} from "@pg-mono/ab-testing";
import {omit} from "@pg-mono/nodash";

import {DSA_RATING_SORT_AB_TEST_ID, isDsaRatingSortTreatmentVariant} from "../../../ab_testing/dsa_rating_sort_ab_test";
import {useAppSelector} from "../../../store/hooks";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {IGetOfferListPayload} from "../../types/GetOfferListPayload";
import {getFetchOfferListQueryData} from "../helpers/get_fetch_offer_list_query_data";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {hasPriceFilter} from "../utils/has_price_filter";

interface IProps {
    latestQuery: IOfferListLatestQuery;
    isLastPage: boolean;
}

export const useFetchAdditionalOfferList = (props: IProps) => {
    const useDsaSort = isDsaRatingSortTreatmentVariant(useAppSelector(abTestingSelector(DSA_RATING_SORT_AB_TEST_ID)));
    const queryWithoutPrice = omit(props.latestQuery, ["price_0", "price_1", "instalment"]);
    const {fullQuery} = getFetchOfferListQueryData(queryWithoutPrice as Record<string, string | string[] | null>, true, useDsaSort);

    const {data: offersWithoutPriceFilterData} = useGetOfferListQuery(fullQuery as IGetOfferListPayload, {
        skip: !props.isLastPage || !hasPriceFilter(props.latestQuery)
    });
    const offersWithoutPriceFilter = offersWithoutPriceFilterData?.results ?? [];

    return offersWithoutPriceFilter;
};
